var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamaskVerticalText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3225_317398)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.844 81.8552L121.082 84.5717V81.0194L121.918 80.1836H127.769V84.3625V87.2878H121.5L113.769 83.9447L110.844 81.8552Z",
    fill: "#CDBDB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.273 81.8552L134.244 84.5717V81.0194L133.408 80.1836H127.558V84.3625V87.2878H133.826L141.557 83.9447L144.273 81.8552Z",
    fill: "#CDBDB2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.914 74.123L121.078 81.0181L122.123 80.1823H132.988L134.242 81.0181L133.406 74.123L131.734 73.0781L123.376 73.2873L121.914 74.123Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.273 27.5273L121.288 39.2284L123.587 73.2871H131.736L134.243 39.2284L138.84 27.5273H116.273Z",
    fill: "#F89C35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.3349 53.2294L88.4844 70.1539L103.111 69.3181H112.513V62.0052L112.095 46.9609L110.006 48.6325L94.3349 53.2294Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.406 55.1094L122.54 55.5273L120.66 64.3031L112.51 62.2136L105.406 55.1094Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.406 55.3164L112.51 62.0027V68.689L105.406 55.3164Z",
    fill: "#EA8D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.516 62.2109L120.874 64.3004L123.59 73.2853L121.709 74.3299L112.516 68.8973V62.2109Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.515 68.8984L110.844 81.8532L121.918 74.1223L112.515 68.8984Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.543 55.5273L123.588 73.2881L120.453 64.1988L122.543 55.5273Z",
    fill: "#EA8E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.898 69.1076L112.51 68.8984L110.838 81.8532L102.898 69.1076Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0812 87.4968L110.842 81.855L102.902 69.1094L88.4844 70.1539L93.0812 87.4968Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.286 39.2305L112.302 46.7526L105.406 55.1105L122.54 55.7375L121.286 39.2305Z",
    fill: "#E8821E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.844 81.8559L121.918 74.125L121.082 80.8113V84.5724L113.56 83.1096L110.844 81.8559Z",
    fill: "#DFCEC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.273 81.8559L133.408 74.125L134.244 80.8113V84.5724L141.766 83.1096L144.273 81.8559Z",
    fill: "#DFCEC3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.944 59.2891L120.242 64.095L112.093 62.0056L117.944 59.2891Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.875 17.707L121.292 39.2284L116.486 27.5274L92.875 17.707Z",
    fill: "#E88F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8704 17.707L89.1094 29.1991L91.1989 41.736L89.7362 42.5718L91.8257 44.4523L90.1541 45.915L92.4525 48.0044L90.9899 49.2581L94.3331 53.4371L110.004 48.6313C117.666 42.5021 121.427 39.3679 121.287 39.2286C121.148 39.0893 111.676 31.9155 92.8704 17.707Z",
    fill: "#8E5A30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.782 53.2294L166.633 70.1539L152.006 69.3181H142.604V62.0052L143.022 46.9609L145.111 48.6325L160.782 53.2294Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.711 55.1094L132.577 55.5273L134.458 64.3031L142.607 62.2136L149.711 55.1094Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.711 55.3164L142.607 62.0027V68.689L149.711 55.3164Z",
    fill: "#EA8D3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.602 62.2109L134.244 64.3004L131.527 73.2853L133.408 74.3299L142.602 68.8973V62.2109Z",
    fill: "#F89D35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.602 68.8984L144.273 81.8532L133.408 74.3311L142.602 68.8984Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.575 55.5273L131.53 73.2881L134.664 64.1988L132.575 55.5273Z",
    fill: "#EA8E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.219 69.1076L142.607 68.8984L144.279 81.8532L152.219 69.1076Z",
    fill: "#D87C30"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.036 87.4968L144.276 81.855L152.216 69.1094L166.633 70.1539L162.036 87.4968Z",
    fill: "#EB8F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.831 39.2305L142.816 46.7526L149.711 55.1105L132.577 55.7375L133.831 39.2305Z",
    fill: "#E8821E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.174 59.2891L134.875 64.095L143.024 62.0056L137.174 59.2891Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.242 17.707L133.825 39.2284L138.631 27.5274L162.242 17.707Z",
    fill: "#E88F35"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.247 17.707L166.008 29.1991L163.918 41.736L165.381 42.5718L163.291 44.4523L164.963 45.915L162.665 48.0044L164.127 49.2581L160.784 53.4371L145.113 48.6313C137.452 42.5021 133.691 39.3679 133.83 39.2286C133.969 39.0893 143.441 31.9155 162.247 17.707Z",
    fill: "#8E5A30"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.213 137.24C212.384 136.038 210.367 135.184 208.457 134.115C207.22 133.421 205.903 132.806 204.827 131.925C202.998 130.429 203.375 127.491 205.284 126.209C208.027 124.392 212.572 125.407 213.056 129.12C213.056 129.2 213.137 129.254 213.218 129.254H217.359C217.467 129.254 217.548 129.174 217.521 129.067C217.306 126.503 216.31 124.366 214.482 123.003C212.734 121.694 210.743 121 208.619 121C197.673 121 196.678 132.513 202.568 136.145C203.24 136.573 209.022 139.457 211.066 140.713C213.11 141.968 213.756 144.265 212.868 146.082C212.061 147.738 209.964 148.886 207.866 148.753C205.58 148.619 203.805 147.391 203.186 145.467C203.079 145.12 203.025 144.452 203.025 144.159C203.025 144.078 202.944 143.998 202.864 143.998H198.372C198.292 143.998 198.211 144.078 198.211 144.159C198.211 147.391 199.018 149.18 201.223 150.81C203.294 152.359 205.553 153 207.893 153C214.024 153 217.198 149.554 217.843 145.975C218.408 142.476 217.359 139.324 214.213 137.24Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2023 121.586H17.2121H15.0337C14.953 121.586 14.8993 121.639 14.8724 121.693L11.1879 133.766C11.1341 133.927 10.9189 133.927 10.8652 133.766L7.18068 121.693C7.15379 121.613 7.10001 121.586 7.01933 121.586H4.84091H2.85076H0.161365C0.0806835 121.586 0 121.666 0 121.746V152.571C0 152.651 0.0806835 152.731 0.161365 152.731H4.65265C4.73334 152.731 4.81402 152.651 4.81402 152.571V129.145C4.81402 128.958 5.08296 128.932 5.13675 129.092L8.84811 141.245L9.11705 142.1C9.14395 142.18 9.19773 142.207 9.27841 142.207H12.7209C12.8015 142.207 12.8553 142.154 12.8822 142.1L13.1511 141.245L16.8625 129.092C16.9163 128.905 17.1852 128.958 17.1852 129.145V152.571C17.1852 152.651 17.2659 152.731 17.3466 152.731H21.8379C21.9186 152.731 21.9993 152.651 21.9993 152.571V121.746C21.9993 121.666 21.9186 121.586 21.8379 121.586H19.2023Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.444 121.586C145.364 121.586 145.31 121.639 145.283 121.693L141.599 133.766C141.545 133.927 141.33 133.927 141.276 133.766L137.591 121.693C137.564 121.613 137.511 121.586 137.43 121.586H130.599C130.518 121.586 130.438 121.666 130.438 121.746V152.571C130.438 152.651 130.518 152.731 130.599 152.731H135.09C135.171 152.731 135.252 152.651 135.252 152.571V129.145C135.252 128.958 135.52 128.932 135.574 129.092L139.286 141.245L139.555 142.1C139.581 142.18 139.635 142.207 139.716 142.207H143.158C143.239 142.207 143.293 142.154 143.32 142.1L143.589 141.245L147.3 129.092C147.354 128.905 147.623 128.958 147.623 129.145V152.571C147.623 152.651 147.703 152.731 147.784 152.731H152.275C152.356 152.731 152.437 152.651 152.437 152.571V121.746C152.437 121.666 152.356 121.586 152.275 121.586H145.444Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5135 121.586H79.1495H74.6582H66.2942C66.2135 121.586 66.1328 121.666 66.1328 121.746V125.593C66.1328 125.673 66.2135 125.753 66.2942 125.753H74.4968V152.571C74.4968 152.651 74.5775 152.731 74.6582 152.731H79.1495C79.2302 152.731 79.3108 152.651 79.3108 152.571V125.753H87.5135C87.5942 125.753 87.6748 125.673 87.6748 125.593V121.746C87.6748 121.666 87.6211 121.586 87.5135 121.586Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.003 152.733H118.091C118.198 152.733 118.279 152.626 118.252 152.519L109.807 121.587C109.78 121.507 109.727 121.48 109.646 121.48H108.086H105.343H103.783C103.702 121.48 103.649 121.534 103.622 121.587L95.1771 152.519C95.1502 152.626 95.2309 152.733 95.3384 152.733H99.4263C99.507 152.733 99.5608 152.679 99.5877 152.626L102.035 143.624C102.062 143.544 102.116 143.517 102.196 143.517H111.233C111.313 143.517 111.367 143.571 111.394 143.624L113.841 152.626C113.868 152.679 113.949 152.733 114.003 152.733ZM103.272 139.11L106.553 127.063C106.607 126.903 106.822 126.903 106.876 127.063L110.157 139.11C110.184 139.217 110.103 139.324 109.996 139.324H103.434C103.326 139.324 103.245 139.217 103.272 139.11Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.714 152.733H187.802C187.909 152.733 187.99 152.626 187.963 152.519L179.518 121.587C179.491 121.507 179.438 121.48 179.357 121.48H177.797H175.054H173.494C173.413 121.48 173.36 121.534 173.333 121.587L164.888 152.519C164.861 152.626 164.942 152.733 165.049 152.733H169.137C169.218 152.733 169.272 152.679 169.299 152.626L171.746 143.624C171.773 143.544 171.827 143.517 171.907 143.517H180.944C181.024 143.517 181.078 143.571 181.105 143.624L183.552 152.626C183.579 152.679 183.633 152.733 183.714 152.733ZM172.983 139.11L176.264 127.063C176.318 126.903 176.533 126.903 176.587 127.063L179.868 139.11C179.895 139.217 179.814 139.324 179.707 139.324H173.144C173.037 139.324 172.956 139.217 172.983 139.11Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2359 148.164V138.602C40.2359 138.521 40.3166 138.441 40.3973 138.441H52.3651C52.4457 138.441 52.5264 138.361 52.5264 138.281V134.435C52.5264 134.355 52.4457 134.274 52.3651 134.274H40.3973C40.3166 134.274 40.2359 134.194 40.2359 134.114V125.94C40.2359 125.86 40.3166 125.78 40.3973 125.78H54.0056C54.0863 125.78 54.167 125.7 54.167 125.62V121.774C54.167 121.693 54.0863 121.613 54.0056 121.613H40.2359H35.5832C35.5026 121.613 35.4219 121.693 35.4219 121.774V125.78V134.301V138.468V148.351V152.572C35.4219 152.652 35.5026 152.732 35.5832 152.732H40.2359H54.5704C54.6511 152.732 54.7317 152.652 54.7317 152.572V148.511C54.7317 148.431 54.6511 148.351 54.5704 148.351H40.3704C40.2897 148.324 40.2359 148.271 40.2359 148.164Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M255.251 152.465L239.707 136.518C239.653 136.465 239.653 136.358 239.707 136.304L253.691 121.88C253.799 121.774 253.718 121.613 253.584 121.613H247.855C247.802 121.613 247.775 121.64 247.748 121.667L235.888 133.9C235.78 134.007 235.619 133.927 235.619 133.794V121.774C235.619 121.693 235.538 121.613 235.457 121.613H230.966C230.885 121.613 230.805 121.693 230.805 121.774V152.598C230.805 152.678 230.885 152.758 230.966 152.758H235.457C235.538 152.758 235.619 152.678 235.619 152.598V139.029C235.619 138.895 235.807 138.815 235.888 138.922L249.335 152.705C249.361 152.732 249.415 152.758 249.442 152.758H255.171C255.278 152.732 255.359 152.545 255.251 152.465Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3225_317398"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.75,
    height: 70.2064,
    fill: "white",
    transform: "translate(88.2734 17.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskVerticalText);
export default __webpack_public_path__ + "static/media/metamask-vertical-text.fbfdefb5c5d75ee321ace76c40a9d2c8.svg";
export { ForwardRef as ReactComponent };